import React, { FunctionComponent } from 'react';

import { Heading, HeadingKindType, MediaBlock1 } from '@savebetter/components';

import { useMediaPercentageProps } from '../hooks/useMediaPercentageProps';

import { LinkProps } from './Link';
import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { RichText, RichTextProps } from './RichText';
import { Section } from './Section';

interface Blok extends PageSectionBlok {
  title: string;
  headingKind: HeadingKindType;
  media: MediaProps[];
  subtitle?: string;
  content: RichTextProps;
  link: LinkProps[];
}

interface MediaSection1Props extends PageSectionProps {
  blok: Blok;
}

export const MediaSection1: FunctionComponent<React.PropsWithChildren<MediaSection1Props>> = ({
  blok,
  sectionClassName
}) => {
  const {
    hasBackground,
    hasBorder,
    title,
    headingKind,
    media = [],
    subtitle,
    content,
    link = [],
    hasPaddingBottom,
    hasPaddingTop
  } = blok;
  const linkProps = link.length > 0 ? { url: link[0].url, text: link[0].text, target: link[0].target } : undefined;

  const heading = subtitle && (
    <Heading
      className="mb-4 mt-large sm:first:mt-12 md:mt-12 lg:mt-large lg:first:mt-0"
      kind="3"
      color="text-black"
      level="3"
    >
      {subtitle}
    </Heading>
  );

  const { getMediaProps } = useMediaPercentageProps();

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader headingKind={headingKind}>{title}</PageSectionHeader>
      <MediaBlock1
        headingPosition="belowMediaContainer"
        addAccordion
        heading={heading}
        link={linkProps}
        mediaProps={getMediaProps(media[0])}
      >
        <RichText content={content} />
      </MediaBlock1>
    </Section>
  );
};
